import React from "react";
import { PLAYER_STATE, STATE } from "../../lib/testLibrary";

export const StatePill = ({ s, testid, player }) => {
  const [l, c] = (player ? PLAYER_STATE : STATE)[s] || [s, "#a3a3a3"];
  return <span style={{ fontSize: 11, fontWeight: 700, color: c, border: `1px solid ${c}55`, padding: "2px 8px", whiteSpace: "nowrap" }} data-testid={testid}>{l}</span>;
};
